import Vue from 'vue';
import Router from 'vue-router';
const HelloiPoker = () => import('@/components/HelloiPoker.vue');
const lineRecord = () => import('@/components/lineRecord.vue');
const lineRecordQA = () => import('@/components/lineRecordQA.vue');
const startTable = () => import('@/components/startTable.vue');
const accounting = () => import('@/components/accounting/index.vue');
const calculator = () => import('@/components/calculator.vue');
const WinningPercentage = () => import('@/components/WinningPercentage.vue');
const HandRecord = () => import('@/components/handRecord/index.vue');
const Tournament = () => import('@/components/tournament/index.vue');
const Gossip = () => import('@/components/gossip/index.vue');
Vue.use(Router);
const routes = [
    {
        path: '',
        redirect: '/HelloiPoker',
    },
    {
        path: '/HelloiPoker',
        name: 'HelloiPoker',
        meta: {
            title: 'iPoker'
        },
        component: HelloiPoker
    },
    {
        path: '/lineRecord',
        name: 'lineRecord',
        meta: {
            title: 'Record your line'
        },
        component: lineRecord
    },
    {
        path: '/lineRecordQA',
        name: 'lineRecordQA',
        meta: {
            title: 'Record your line'
        },
        component: lineRecordQA
    },
    {
        path: '/startTable',
        name: 'startTable',
        meta: {
            title: '起手表'
        },
        component: startTable
    },
    {
        path: '/accounting',
        name: 'accounting',
        meta: {
            title: 'iPoker記帳機'
        },
        component: accounting
    },
    {
        path: '/WinningPercentage',
        name: '勝率計算機',
        meta: {
            title: 'iPoker勝率機'
        },
        component: WinningPercentage
    },
    {
        path: '/tool/:id?',
        name: 'calculator',
        meta: {
            title: '設定追蹤清單'
        },
        component: calculator
    },
    {
        path: '/handRecord',
        name: 'handRecord',
        meta: {
            title: '手牌記錄器'
        },
        component: HandRecord
    },
    {
        path: '/tournaments',
        name: 'Tournament',
        meta: {
            title: '比賽查詢'
        },
        component: Tournament
    },
    {
        path: '/gossip',
        name: 'Gossip',
        meta: {
            title: '八卦板'
        },
        component: Gossip
    }
];
const router = new Router({
    mode: 'history',
    base: '/',
    routes
});
let targetPath = '/';
router.beforeEach((to, _from, next) => {
    targetPath = to.fullPath;
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});
router.onError((error) => {
    // After a deploy the old chunk files are gone; reload to pick up the new index.html.
    // Go to the target route: a failed first navigation has already reset the URL to '/'.
    if (!/Loading (CSS )?chunk/.test(error.message)) {
        return;
    }
    try {
        const lastReload = Number(sessionStorage.getItem('chunkReloadTime'));
        if (Date.now() - lastReload > 10000) {
            sessionStorage.setItem('chunkReloadTime', String(Date.now()));
            window.location.assign(targetPath);
        }
    }
    catch (err) {
        console.error('Reload after chunk error failed:', err);
    }
});
export default router;
